import { useLayoutEffect, useMemo } from "react";
// recoil
import { useRecoilValue } from "recoil";
// @Mui
import {
  createTheme,
  ThemeProvider as MUIThemeProvider,
} from "@mui/material/styles";
// atoms
import { themeAtom } from "../recoil";
//
import palette from "./palette";
import typography from "./typography";
import breakpoints from "./breakpoints";
import componentsOverride from "./overrides";
import shadows, { customShadows } from "./shadows";
import useLocales from "src/hooks/useLocales";

// -------------------------------------------------------------------------

function ThemeProvider({ children }) {
  const themeState = useRecoilValue(themeAtom);

  const { currentLang } = useLocales();

  const themeOptions = useMemo(
    () => ({
      palette: themeState.mode === "light" ? palette.light : palette.dark,
      typography,
      breakpoints,
      shape: { borderRadius: 5 },
      direction: themeState.dir,
      shadows: themeState.mode === "light" ? shadows.light : shadows.dark,
      customShadows:
        themeState.mode === "light" ? customShadows.light : customShadows.dark,
    }),
    [themeState]
  );

  const theme = createTheme({ ...themeOptions, ...currentLang.systemValue });

  theme.components = componentsOverride(theme);

  useLayoutEffect(() => {

    document.documentElement.setAttribute("dir",themeState.dir);
  }, [document, themeState]);

  return <MUIThemeProvider theme={theme}>{children}</MUIThemeProvider>;
}

export default ThemeProvider;
